import { createOptionsAtomDescending } from '@/utils/atoms/generic';
import { seasonsAtom } from '@/atoms/queries/seasons';

export const eventDataSeasonsOptionsAtom = createOptionsAtomDescending(seasonsAtom, 'name', 'season_id');
